import React, { useState, useRef } from "react";
import { useEffect } from "react";

import cx from "classnames";

import styles from "./bannerVideo.module.scss";
import { useDesktop } from "services/responsive";

export default function VideoSection() {
  const [loading, setLoading] = useState(true);
  const videoRef = useRef(null);
  const mobileVideoRef = useRef(null);
  const section = useRef(null);
  const mobileSection = useRef(null);
  const [pageYOffset, setPageYOffset] = useState(window.pageYOffset);

  const desktop = useDesktop();

  const onVideoLoaded = () => {
    setLoading(false);
  };

  useEffect(() => {
    const vid = desktop ? videoRef.current : mobileVideoRef.current;
    const videoBanner = desktop ? section : mobileSection;

    if (!vid || !videoBanner?.current) return;

    const playbackConst = desktop ? 460 : 420;

    if (desktop) {
      vid.addEventListener('loadedmetadata', function () {
        videoBanner.current.style.height = Math.floor(vid.duration) * playbackConst + "px";
      });

      vid.pause();

      const onScroll = () => {
        setPageYOffset(window.pageYOffset);
        vid.pause();
      };
      window.addEventListener('scroll', onScroll);

      const onInterval = () => {
        vid.currentTime = window.pageYOffset / 400;
      };
      const intervalId = setInterval(onInterval, 80);

      return () => {
        window.removeEventListener('scroll', onScroll);
        clearInterval(intervalId);
      };
    }

    else {
      let isVideoReady = false;
      let animationFrameId;

      const handleMetadata = () => {
        if (!vid.duration || isNaN(vid.duration)) return;

        videoBanner.current.style.height = `${Math.floor(vid.duration) * playbackConst}px`;
        isVideoReady = true;
        vid.pause();
        animationFrameId = requestAnimationFrame(updateVideoTime);
      };

      const updateVideoTime = () => {
        if (!isVideoReady || !vid.duration || isNaN(vid.duration)) {
          animationFrameId = requestAnimationFrame(updateVideoTime);
          return;
        }

        const scrollTime = window.pageYOffset / 400;
        vid.currentTime = Math.min(scrollTime, vid.duration);
        animationFrameId = requestAnimationFrame(updateVideoTime);
      };

      const onScroll = () => {
        setPageYOffset(window.pageYOffset);
      };

      vid.addEventListener('loadedmetadata', handleMetadata);
      window.addEventListener('scroll', onScroll);

      if (vid.readyState >= 1) {
        handleMetadata();
      } else {
        vid.load();
      }

      return () => {
        vid.removeEventListener('loadedmetadata', handleMetadata);
        window.removeEventListener('scroll', onScroll);
        cancelAnimationFrame(animationFrameId);
      };
    }
  }, [desktop]);

  return (
    <>
      {loading && (
        <div id="loader">
          <div class="preLoader">
            <video autoplay="true" muted playsinline loop>
              <source src="loader.mp4" type="video/mp4" />
            </video>
            <p>Get ready for gravity...</p>
          </div>
        </div>
      )}

      {desktop &&
        <div className={styles.videoDesktop}>
          <div ref={section} className={styles.spacer}>
          </div>
          {!loading &&
            <div className={cx(styles.messageContainer, { [styles.hideMessage]: pageYOffset > 0 })}>
              <span className={styles.videoMessage}>Scroll To Fall In Love</span>
              <i className={cx('cleverstory-drop-down', styles.scrolldownIcon)} />
            </div>
          }
          <video ref={videoRef} onLoadedData={onVideoLoaded}>
            <source type="video/mp4" src="https://ik.imagekit.io/zvzrxdvzjue/5adebd333a038c2136412d80/videos/63ef87e5ac5f65425ed7db83/ee14995d-0741-4d18-8e50-70b06ca6c70a.mp4.mp4" />
          </video>
        </div>
      }

      <div className={styles.videoMobile}>
        <div ref={mobileSection} className={styles.spacer}></div>
        { !loading &&
          <div className={cx(styles.messageContainer, { [styles.hideMessage]: pageYOffset > 0 })}>
            <span className={styles.videoMessage}>Scroll To Fall In Love</span>
            <i className={cx('cleverstory-drop-down', styles.scrolldownIcon)} />
          </div>
        }
        <video ref={mobileVideoRef} preload="auto" onLoadedData={onVideoLoaded} playsInline autoPlay muted >
          <source type="video/mp4" src="/images/banner/bannerVidSmall.mp4" />
        </video>
      </div>
    </>
  );
}
